<tax-page-header titleText="cto.edit.permissions"></tax-page-header>

<div class="ui-kit-content-container">
  <div data-qa-block="cto-info">
    <p class="block_title" translate data-qa="block-title">menu.cto</p>
    <div class="layout-2-column">
      <span data-qa="cto-name">{{ ctoContract?.cto?.name }}</span>
      <!--TODO: fix $any-->
      <tax-cto-status
        [createdAt]="$any(ctoContract?.createdAt)"
        [updatedAt]="$any(ctoContract?.updatedAt)"
        [endsAt]="$any(ctoContract?.endsAt)"
        [status]="$any(ctoContract?.status)"
      >
      </tax-cto-status>
    </div>
    <div class="grey-text">
      <div data-qa="address">
        {{ 'cto.info.address' | translate }}
        {{ ctoContract?.cto?.address }}
      </div>
      <div data-qa="iin-bin">
        {{ 'cto.info.iin' | translate }}
        {{ ctoContract?.cto?.iinOrBin }}
      </div>
      <div data-qa="contacts">
        {{ 'cto.info.phone' | translate }}
        {{ ctoContract?.cto?.contacts }}
      </div>
      <div
        class="text-block"
        data-qa-block="kkm-models"
        data-qa-button="toggle-list-visibility"
        (click)="isModelVisible = !isModelVisible"
      >
        <span translate>cto.info.kkm.models</span>
        <!--TODO: fix $any-->
        <span [ngStyle]="$any(isModelVisible && { display: 'none' })">
          <svg-icon key="expand-more"></svg-icon>
        </span>
        <!--TODO: fix $any-->
        <span [ngStyle]="$any(!isModelVisible && { display: 'none' })">
          <svg-icon key="expand-less"></svg-icon>
        </span>
      </div>
      <!--TODO: fix $any-->
      <div
        class="description"
        [ngStyle]="$any(!isModelVisible && { display: 'none' })"
        data-qa="kkm-models"
      >
        <!--TODO: fix $any-->
        <ng-container
          *ngFor="
            let model of getServicedModels($any(ctoContract?.cto?.servicedModels));
            last as isLast
          "
        >
          {{ model }}<ng-container *ngIf="!isLast">,</ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="greyline" />

  <tax-param-block
    [title]="'menu.kkms'"
    [placeholder]="'cto.add.kkm.placeholder'"
    (createModal)="createComponent()"
    [modalId]="'kkms'"
    [details]="convertKkmIdsToString(kkmIds)"
  ></tax-param-block>

  <ng-template *ngIf="ctoContract && ctoContract.permissions.length">
    <hr class="greyline" />
    <div data-qa-block="permissions">
      <div class="block_title" translate data-qa="block-title">cto.add.modules.title</div>
      <div class="description grey-text" data-qa="permissions">
        <ng-container *ngFor="let permission of ctoContract?.permissions; last as isLast">
          {{ permission }}<ng-container *ngIf="!isLast">,</ng-container>
        </ng-container>
      </div>
    </div>
  </ng-template>

  <div class="ui-kit-bottom-buttons-block">
    <button data-qa-button="go-back" class="back-button" (click)="goBack()" translate>
      group.back
    </button>

    <tax-checkbox
      class="checkbox"
      [id]="'contract'"
      [(ngModel)]="userAgreement"
      [labelTemplate]="contractTemplate"
      data-qa-checkbox="confirm"
    ></tax-checkbox>
    <ng-template #contractTemplate>
      <a href="/api/cto/load-contract-pdf" target="_blank">
        <span translate>registration.offer.confirm.first.part</span>
      </a>
      {{ 'registration.offer.confirm.second.part' | translate }}
    </ng-template>

    <button
      data-qa-button="update-cto"
      class="button_blue"
      (click)="saveCto()"
      [disabled]="!canSaveCto()"
      translate
    >
      group.save
    </button>
  </div>
</div>
